import type { ReactNode } from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";

type MenuHelpActionProps = {
  label: string;
  description: string;
  icon: ReactNode;
  badge?: number;
  accent?: boolean;
  featured?: boolean;
  disabled?: boolean;
  onClick: () => void;
};

/** A single accessible action; explanatory text is not a separate clickable control. */
export function MenuHelpAction({ label, description, icon, badge, accent = false, featured = false, disabled, onClick }: MenuHelpActionProps) {
  return <button type="button" disabled={disabled} onClick={onClick} className={cn("flex w-full items-start gap-3 rounded border bg-card px-3 py-3 text-left transition-colors hover:bg-accent/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50", (accent || featured) && "border-[#a13b6e]/45 bg-[#a13b6e]/5", featured && "border-[#a13b6e] bg-[#a13b6e]/10")}>
    <span className="mt-0.5 shrink-0 text-[#a13b6e] [&_svg]:size-5">{icon}</span>
    <span className="min-w-0 flex-1"><span className="flex flex-wrap items-center gap-2 text-sm font-semibold">{label}{Boolean(badge) && <span className="rounded-full bg-[#a13b6e] px-1.5 py-0.5 text-[10px] text-white">{badge}</span>}</span><span className="mt-1 block text-xs leading-5 text-muted-foreground">{description}</span></span>
    <ChevronRight className="mt-1 size-4 shrink-0 text-muted-foreground" />
  </button>;
}
